import {Component, Input, OnInit} from '@angular/core';
import {TestResult} from '../../../data/models/result/test-result';
import {Test} from '../../../data/models/test/test';
import {TEST_RESULT_PRIVILEGES} from '../../../../constants/privileges';

@Component({
  selector: 'app-test-result',
  templateUrl: './test-result.component.html',
  styleUrls: ['./test-result.component.css']
})
export class TestResultComponent implements OnInit {

  readonly PRIVILEGES = TEST_RESULT_PRIVILEGES;

  @Input() test!: Test;
  @Input() testResult!: TestResult;

  constructor() {
  }

  ngOnInit(): void {
  }

  isExpired(): boolean {
    if (this.testResult.expiryDate) {
      return new Date(this.testResult.expiryDate).getTime() < new Date().getTime();
    }
    return false;
  }

}
